<app-layout>
  <!-- *ngIf="lojistik" -->
    <!-- <dl class="row" >
        <dt class="col-5">Şube:</dt>
        <dd class="col-7">Şube ismi</dd>
        <dt class="col-5">Cari:</dt>
        <dd class="col-7">Cari adı</dd>
        <dt class="col-5">Fiyatlama Tarihi:</dt>
        <dd class="col-7">Fiyat tarihi</dd>
        <dt class="col-5">Mazot Baz Fiyatı:</dt>
        <dd class="col-7">Mazot Baz Fiyatı TL</dd>
        <dt class="col-5">Açıklama</dt>
        <dd class="col-7">Lojistik adı</dd>
      </dl> -->
      <app-lojistik-irsaliye-liste *ngIf="lojistikIrsaliyeList" [lojistikIrsaliyeList]="lojistikIrsaliyeList" >
      </app-lojistik-irsaliye-liste>
</app-layout>
